import { render, staticRenderFns } from "./Supervision.vue?vue&type=template&id=485f6870&scoped=true"
import script from "./Supervision.vue?vue&type=script&lang=js"
export * from "./Supervision.vue?vue&type=script&lang=js"
import style0 from "./Supervision.vue?vue&type=style&index=0&id=485f6870&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../shieldgo-admin-web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "485f6870",
  null
  
)

export default component.exports